import { createDraftSafeSelector, createSelector, createSlice } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import { carBrandApi } from 'src/api/car-brand-api';
import { listPageConfig } from 'src/config';
import { memoizePick } from 'src/utils/memoize-pick';

const initialState = {
  pageState: {
    view: 'list',
    page: 0,
    rowsPerPage: listPageConfig.rowPerpage,
    filters: {
      query: '',
      actived: 'all'
    },
    sortBy: 'createdAt',
    sortDir: 'desc'
  }
};

export const carBrandSlice = createSlice({
  name: 'carBrand',
  initialState,
  reducers: {
    resetState: () => initialState,
    resetPageState: (state) => {
      state.pageState = initialState.pageState;
    },
    changePageState: (state, action) => {
      state.pageState = { ...state.pageState, ...action.payload };
    },
    resetFilters: (state) => {
      state.pageState.filters = initialState.pageState.filters;
    },

    changeFilters: (state, action) => {
      state.pageState.filters = { ...state.pageState.filters, ...action.payload };
    },
    removeFilter: (state, action) => {
      state.pageState.filters = omit(state.pageState.filters, action.payload);
    }
  }
});

// Action creators are generated for each case reducer function
export const { resetState, resetPageState, changePageState, resetFilters, changeFilters, removeFilter } = carBrandSlice.actions;

// Selectors
export const selectCarBrandPageState = ({ carBrand }) => carBrand.pageState;

export const selectCarBrandPageStatePart = createDraftSafeSelector(
  selectCarBrandPageState,
  (_, keys = []) => keys,
  (pageState, keys) => {
    console.log('selectCarBrandPageStatePart state', pageState);
    return memoizePick(pageState, keys);
  }
);

export const selectCarBrandPageStateView = ({ carBrand }) => carBrand.pageState.view;
export const selectCarBrandListOptionsResult = carBrandApi.endpoints.getCarBrandListOptions.select();

export const selectCarBrandListOptionsData = createSelector(
  selectCarBrandListOptionsResult,
  (carBrandListOptionsResult) => carBrandListOptionsResult.data ?? []
);

// Reducer
export default carBrandSlice.reducer;
